// Polyfills for js features used in the Dashboard but not supported in some browsers (mainly IE)
import '@/polyfills';
// Notifications plugin. Used on Notifications page
import Notifications from '@/components/NotificationPlugin';
// Validation plugin used to validate forms
import { configure } from 'vee-validate';
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents';
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives';
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from '@/components/SidebarPlugin';
import LaravelPermissionToVueJS from 'laravel-permission-to-vuejs'
// element ui language configuration
import langUI from 'element-ui/lib/locale/lang/en';
import localeUI from 'element-ui/lib/locale';
import VueCookies from 'vue-cookies'
import VueAxios from 'vue-axios';
import Axios from 'axios';
import ObjectToFD from 'vue-object-to-formdata';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Notify from 'vue-notifyjs'
localeUI.use(langUI);

// vue-bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// asset imports
import '@/assets/scss/argon.scss';
import '@/assets/vendor/nucleo/css/nucleo.css';
import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import messagesRules from 'vee-validate/dist/locale/es.json';



Object.keys(rules).forEach(rule => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: messagesRules.messages[rule] // assign message
  });
});
import Lang from 'lang.js';

import messages from '../../assets/js/ll_messages';
const default_locale = process.env.MIX_LOCALE;
const fallback_locale = process.env.MIX_LOCALE;

export default {
    install(Vue) {

        Vue.use(GlobalComponents);
        Vue.use(GlobalDirectives);
        Vue.use(SideBar);
        Vue.use(Notifications);
        Vue.use(BootstrapVue);
        Vue.use(IconsPlugin);
        Vue.use(LaravelPermissionToVueJS);
        Vue.use(VueCookies);
        Vue.use(VueAxios, Axios);
        Vue.use(ObjectToFD);
        Vue.use(VueSweetalert2, {confirmButtonColor: '#41b882', cancelButtonColor: '#41b882'});
        Vue.use(Notify, {type: 'primary', timeout: 2000, horizontalAlign: 'right', verticalAlign: 'top'})
        if (Vue.$cookies.isKey('jwt')) {
            window.axios.defaults.headers.common["Authorization"] = `Bearer ${Vue.$cookies.get('jwt')}`;
        } else {
            delete window.axios.defaults.headers.common["Authorization"];
        }
        Vue.prototype.trans = new Lang( { messages, locale: default_locale, fallback: fallback_locale } );

        configure({
            classes: {
                valid: 'is-valid',
                invalid: 'is-invalid',
                dirty: ['is-dirty', 'is-dirty'], // multiple classes per flag!
            }
        })
    }
};
